import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { LogDelete } from '../../services';

export const fetchLogDelete = createAsyncThunk(
    'logDelete/fetchLogDelete',
    async ({ id }) => {
        const response = await LogDelete(id)
        return response.result
    }
);

const logDeleteSlice = createSlice({
    name: 'logDelete',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchLogDelete.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchLogDelete.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchLogDelete.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default logDeleteSlice.reducer;
